import { React, lazy, useEffect } from "react";
import useAuth from "../store/auth";
import { useNavigate } from "react-router-dom";
const Navbar = lazy(() => import("../layouts/navbar/Navbar"));
const Sidebar = lazy(() => import("../layouts/sidebar/Sidebar"));

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // if (user?.id && !user?.onroud) {
    //   navigate("/dashboard/signature");
    // }
  }, [user]);
  return (
    <>
      <div>
        <Sidebar />
        <div className="page">
          <Navbar />
          <div className="content">{children && children}</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
